const ga_push = (event, category, action, label) => {
    var data = {
      event: event,
      Category: category,
      Action: action,
      Label: label,
    };
    if (window.dataLayer) {
      window.dataLayer.push(data);
    }
    if (
      window.location.href.includes("localhost") ||
      window.location.href.includes("qa")
    ) {
      console.log(data)
    }
  };
  
  export { ga_push };
  